import { _ } from "../../core/polyglot/polyglot.js";
import AbstractBusinessTrendComparisonElement from "./AbstractBusinessTrendComparisonElement.js";

/**
 * Represents a fiscal year for the user to compare to the current
 * fiscal year.
 *
 * @param {FiscalYear} fiscalYear
 */
export default class FiscalYearBusinessTrendComparisonElement extends AbstractBusinessTrendComparisonElement {
	constructor({ fiscalYear }) {
		super(...arguments);

		this._fiscalYear = fiscalYear;
	}

	getId() {
		return this._fiscalYear.getId();
	}

	getName() {
		return this._fiscalYear.toSmartString();
	}

	getGroupName() {
		return _("Fiscal years");
	}

	fetchAnnualTrend({ fetchAnnualTrendForFiscalYear }) {
		return fetchAnnualTrendForFiscalYear(this._fiscalYear.getId());
	}

	_getFiscalYear() {
		return this._fiscalYear;
	}
}
